import { render } from "./MainPageLoader.vue?vue&type=template&id=4c7cbce0&scoped=true"
import script from "./MainPageLoader.vue?vue&type=script&lang=js"
export * from "./MainPageLoader.vue?vue&type=script&lang=js"

import "./MainPageLoader.vue?vue&type=style&index=0&id=4c7cbce0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7cbce0"]])

export default __exports__